module.exports = __webpack_public_path__ + "img/iphone-charging-SPAIN-es.72713ccf.webp";